import React from "react";
import { BlogPost } from "../../../../typings/blogs";
import clock from "../../../../assets/images/time-clock.svg";
import ContentfulImage from "../../../common/utils/ContentfulImage";
import { Link } from "react-router-dom";
import Avatar from "../../../common/utils/Avatar";

const LatestBlog = ({ blog }: { blog: BlogPost }) => {
  const {
    title,
    slug,
    bannerImage,
    category,
    minuteRead,
    description,
    authorName,
    authorImage,
  } = blog.fields;
  return (
    <Link
      to={`/insights-stories/${slug}`}
      className="flex flex-col md:flex-row items-center w-full gap-16"
    >
      <div className="w-full md:w-1/2">
        <ContentfulImage
          src={bannerImage.fields.file.url}
          alt={`author-img ${title}`}
          className="w-full max-h-[340px] rounded-xl object-cover"
        />
      </div>
      <div className="w-full md:w-1/2 flex flex-col gap-4">
        <div className="flex items-center justify-between">
          <div className="bg-primary/10 py-0.5 px-3 rounded text-primary text-sm">
            {category}
          </div>
        </div>
        <div className="flex flex-col gap-3">
          <h3 className="text-textBlack text-[32px] font-semibold line-clamp-3">
            {title}
          </h3>
          <span className="text-textBlack text-[20px] line-clamp-3">
            {description}
          </span>
        </div>
        <div className="flex items-center w-full justify-between">
          <div className="flex gap-2 items-center">
            <Avatar
              src={authorImage.fields.file.url}
              alt={`author-img ${title}`}
              name={authorName}
              className="size-[24px] rounded-full object-cover"
            />
            {/* <ContentfulImage
              src={authorImage.fields.file.url}
              alt={`author-img ${title}`}
              className="size-[24px] rounded-full object-cover"
            /> */}
            <span className="text-textBlack2 text-[14px]">{authorName}</span>
          </div>
          <div className="flex items-center gap-1">
            <img src={clock} className="size-7" alt="" />
            <span className="text-textBlack2 text-[14px]">
              {minuteRead} min read
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default LatestBlog;
